import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { HoldingOwner } from '../../models/polymer/HoldingOwner.model';
import { HouseholdFormData, ReasonFormData } from '../../models/classes/ApplicationStep1.class';
import { P2Accordion, P2Alert, P2Button, P2DateSelector, P2TextInput, P2TextLabel } from 'react-bootstrap-common-script';
import { OwnershipReasonEnum } from '../../models/enum/ownership-reason.enum';
import { ReasonEnum } from '../../models/enum/reason.enum';
import { useForm } from '../../hooks/use-form';
import { Dropdown } from '../dropdown';
import { incomingOwnerCitizenshipDropdownItems, incomingOwnerRelatedToAboveItems, incomingOwnerRelatedToAboveItemsSubsequent, maritalStatusDropdownItems, nationalityDropdownItems, ownerChildrenCareItems, raceDropdownItems, sexDropdownItems } from '../../utils/shared-dropdown';
import { ResidentialStatusEnum } from '../../models/enum/residential-status.enum';
import { ChildrenCareControlEnum } from '../../models/enum/children-care-control.enum';
import RadioGroup from '../form/grouped/radio/radio-group';
import { isRelatedToOwner } from '../../utils/shared-radio';
import { validateIndividualHoldingOwner } from '../../utils/validator';
import { Owner } from '../../models/polymer/Owner.model';
import { InfoCard } from '../info';
import DangerCircle from '../../assets/svg/danger-circle';
import { Helpers } from '../../utils/helper';
import SingpassMyInfo from '../singpass/singpass-myinfo';
import { useAppDispatch, useAppSelector } from '../../redux/hook';
import { retrieveMyInfoByNRIC } from '../../redux/slices/authentication-slice';
import { LottieLoader } from '../loader';
import useRetrieveMyInfo from '../../hooks/use-retrieve-myinfo';
import { MyInfo } from '../../models/polymer/MyInfo.model';
import AccordionTitle from './new-owner-accordions-components/accordion-title';
import { checkDOB } from '../../utils/form-helper';
import SpouseForm from './spouse-form';
import { MaritalStatusEnum } from '../../models/enum/marital-status.enum';
import { PolymerCrypto } from '../../utils/encryptor';
import { namePattern } from '../../utils/shared-pattern';
import { SharedValidators } from '../../utils/validators/shared/validators';

interface NewOwnerAccordionProps {
  proposed_nric?: string[],
  householdFormValues: HouseholdFormData,
  // variant?: "existing" | "new";
  // holdingFormErrors?: any;
  item: HoldingOwner;
  reasonValues?: ReasonFormData;
  isIncoming?: boolean;
  onRemove?: () => void;
  onAdd?: () => void;
  onUpdate?: () => void;
  onToggle?: (isOpen: boolean) => void;
  isDefaultOpen?: boolean;
  holdingIncomingOwnerHandler?: (id: string, value: string | boolean, type: string) => void;
  index: number,
  isMyInfoVariant: boolean,
  loginUserStructureStatus?: string,
  onBindMyInfo?: (nric: string, myInfoData:MyInfo) => void,
  onUnBindMyInfo?: (nric: string) => void,
  singpassToken?: string
  forceError?: boolean
  hasCurrentOwner?: boolean,
  initialHouseholdNrics?: string[]
}

interface AdditionalFormProps {
  itemHoldingErrors: any,
  allowToggle: boolean,
  isToShowChildCareControl: boolean
}

const ExistingMyInfoUserForms = ({ ...props }: NewOwnerAccordionProps & AdditionalFormProps) => {
  const { itemHoldingErrors, allowToggle, isToShowChildCareControl } = props
  const { owners, occupiers, incoming_owners } = props.householdFormValues;

  const firstOwnerName = incoming_owners && incoming_owners.length > 0 ? incoming_owners[0].myinfo.name : "";
  const isFirst = props.index === 0;

  const isFromCurrentHousehold = owners.some(owner => owner.myinfo.uinfin === props.item.myinfo.uinfin) || occupiers.some(occupier => occupier.myinfo.uinfin === props.item.myinfo.uinfin)
  const isPersonalDetailsShow =
    !props.hasCurrentOwner ||
    isFromCurrentHousehold ||
    (props.item?.relationship_with_owner !== "" && itemHoldingErrors?.myinfo?.name?.isValid && itemHoldingErrors?.myinfo?.uinfin?.isValid);

  const disableFields = !allowToggle && props.item.is_proposed;
  const handleValueChange = (id: string, key: string) => (value: string | boolean) => {
    props?.holdingIncomingOwnerHandler?.(id, value, key);
  }

  const handleMonthlyIncomeChange = (id: string) => (value: string) => {
    let updatedValue = Helpers.formatCurrencyInput(value, false);
    props?.holdingIncomingOwnerHandler?.(id, updatedValue, "gross_monthly_income");
  }

  const handleMonthlyIncomeBlur = (id: string) => (value: string) => {
    if (value) {
      let updatedValue = Helpers.formatCurrencyInput(value, true);
      props?.holdingIncomingOwnerHandler?.(props.item?.id, updatedValue, 'gross_monthly_income');
    }
  }

  const handleSpouseFormValueChange = (value:any, field:string)=>{
    handleValueChange(props.item.id, field)(value);
  }

  return (
    <>
      <p hidden>1</p>
      {isFirst && !isFromCurrentHousehold && SharedValidators.Uinfin(props.item.myinfo.uinfin).isValid ? (
        <>
          <div style={{ marginTop: 12 }}>
            <P2TextLabel bold="700" color={"#000"} label={"Relationship"} />
          </div>
          <div style={{ marginTop: 24 }}>
            <Dropdown
              forceError={props.forceError}
              required
              disabled={disableFields}
              selectedDropdown={props.item?.relationship_with_owner}
              placeholder="Please indicate relationship with owner"
              label="How is this proposed owner related to the current owner(s)?"
              items={incomingOwnerRelatedToAboveItemsSubsequent}
              setSelectedDropdown={handleValueChange(props.item.id, "relationship_with_owner")}
            />
          </div>
        </>
      ) : null}
      
      {!isFirst && <>
        <div style={{ marginTop: 12 }}><P2TextLabel bold="700" color={"#000"} label={"Relationship"} /></div>
        <div style={{ marginTop: 17 }}>
          <RadioGroup style={{ marginTop: 24 }} disabled={disableFields} layout={'default'} items={isRelatedToOwner} onItemSelect={handleValueChange(props.item.id,"is_related")} value={props.item?.is_related} label={`Is this proposed owner related to ${firstOwnerName}?`} />
        </div>

        {props.item?.is_related && <div style={{ marginTop: 24 }}>
          <Dropdown forceError={props.forceError} required disabled={disableFields} selectedDropdown={props.item?.relationship_with_owner} placeholder="Please indicate relationship with owner"
            label={`How is this proposed owner related to ${firstOwnerName}?`} items={incomingOwnerRelatedToAboveItems}
            setSelectedDropdown={handleValueChange(props.item.id,"relationship_with_owner")}
          />
        </div>}

        <div style={{ marginTop: 24 }}><P2TextLabel bold="700" color={"#000"} label={"Personal Details"} /></div>
      </>}
      <div style={{ marginTop: isFirst ? 24 : 12 }}>
        <P2TextInput forceError={props.forceError} disabled={props.isMyInfoVariant || disableFields} isError={((!itemHoldingErrors?.myinfo?.uinfin?.isValid) && !disableFields)} errorMsg={itemHoldingErrors?.myinfo?.uinfin?.message} required value={props.item?.myinfo?.uinfin?.toString()} name='uinfin' label='NRIC' maxLength={9} placeholder='Please enter NRIC' type='text' onChange={handleValueChange(props.item.id,"uinfin")} />
      </div>
      <div style={{ marginTop: 24 }}>
        <P2TextInput pattern={namePattern} forceError={props.forceError} value={props.item?.myinfo?.name?.toString()} required disabled={true} name='name' label='Full name' maxLength={9} placeholder='Please enter full name' type='text' onChange={handleValueChange(props.item.id,"name")} />
      </div>

      {isPersonalDetailsShow ? (
        <>
          <div style={{ marginTop: 24 }}>
            <Dropdown forceError={props.forceError} required disabled={props.isMyInfoVariant || disableFields} selectedDropdown={props.item?.myinfo?.sex} placeholder="Please indicate sex" label="Sex" variant="small" items={sexDropdownItems} setSelectedDropdown={handleValueChange(props.item.id,"sex")}
            />
          </div>
          <div style={{ marginTop: 24 }}>
            <Dropdown forceError={props.forceError} required disabled={(props.isMyInfoVariant && !!props.item?.myinfo?.race) || disableFields} selectedDropdown={props.item?.myinfo?.race} placeholder="Please indicate race" label="Race" variant="small" items={raceDropdownItems} setSelectedDropdown={handleValueChange(props.item.id,"race")}
            />
          </div>
          <div style={{ marginTop: 24 }}>
            <Dropdown forceError={props.forceError} required disabled={props.isMyInfoVariant || disableFields} selectedDropdown={props.item?.myinfo?.residential_status} placeholder="Please indicate residential status" label="Residential status" variant="small" items={incomingOwnerCitizenshipDropdownItems} setSelectedDropdown={handleValueChange(props.item.id,"residential_status")}
            />
            {props.item?.myinfo?.residential_status === ResidentialStatusEnum.not_applicable && <div style={{ marginTop: 24 }}> <P2Alert variant={"danger"} text={"Only a Singapore citizen or Permanent Resident may own an HDB flat."}></P2Alert>
            </div>}
          </div>
          <div style={{ marginTop: 24 }}>
            <Dropdown forceError={props.forceError} required disabled={props.isMyInfoVariant || disableFields || props.item?.myinfo?.residential_status === ResidentialStatusEnum.citizen} selectedDropdown={props.item?.myinfo?.nationality} placeholder="Please indicate nationality" label="Nationality" variant="small" items={nationalityDropdownItems} setSelectedDropdown={handleValueChange(props.item.id,"nationality")}
            />
          </div>

          <div style={{ marginTop: 24 }}>
            <P2DateSelector forceError={props.forceError} disabled={props.isMyInfoVariant || disableFields} isError={!itemHoldingErrors?.myinfo?.dob?.isValid} errorMsg={itemHoldingErrors?.myinfo?.dob?.message} value={props.item?.myinfo?.dob} required placeholder="DD/MM/YYYY" label="Date of birth" onChange={handleValueChange(props.item.id,"dob")}
            />
          </div>

          <div style={{ marginTop: 24 }}>
            <P2TextInput forceError={props.forceError} disabled={disableFields} isError={!itemHoldingErrors?.gross_monthly_income?.isValid} errorMsg={itemHoldingErrors?.gross_monthly_income?.message} value={Helpers.formatThousandSeparator(props.item.gross_monthly_income, "$ ")} maxLength={30} required name='gross_monthly_income' label='Gross monthly income' type='text' onBlur={handleMonthlyIncomeBlur(props.item.id)} onChange={handleMonthlyIncomeChange(props.item.id)} />
          </div>

          {props.item?.myinfo?.residential_status === ResidentialStatusEnum.pr &&
            <>
              <div style={{ marginTop: 24 }}>
                <P2DateSelector isError={!itemHoldingErrors?.spr_obtained_date?.isValid} errorMsg={itemHoldingErrors?.spr_obtained_date?.message} forceError={props.forceError} disabled={disableFields} value={props.item?.spr_obtained_date} required placeholder="DD/MM/YYYY" label="Date of obtaining SPR status" maxInput={new Date().toISOString().split("T")[0].toString()} onChange={handleValueChange(props.item.id,"spr_obtained_date")}/>
              </div>
              {!checkDOB(props.item?.spr_obtained_date, 3) && <div style={{ marginTop: 32 }}>
                <InfoCard
                    className="polymer-alert-card"
                    style={{ backgroundColor: "#FFF0C9", color: "#80460D" }}
                    description={
                      <div>An individual Singapore Permanent Resident (SPR) would need to obtain his/her SPR status for at least 3 years to be eligible as one of the proposed owners, if the other owners are also SPRs.</div>
                    }
                    icon={<DangerCircle color="#80460D" />}
                  />
              </div>}
            </>
          }

          <div style={{ marginTop: 24 }}>
            <Dropdown forceError={props.forceError} disabled={disableFields} required selectedDropdown={props.item?.myinfo?.marital_status} placeholder="Please indicate marital status" label="Marital status" items={maritalStatusDropdownItems} setSelectedDropdown={handleValueChange(props.item.id,"marital_status")}
            />      
          </div>

          {isToShowChildCareControl && <div style={{ marginTop: 24 }}>
            <Dropdown forceError={props.forceError} required disabled={disableFields} selectedDropdown={props.item?.children_care_and_control} placeholder="Please indicate owner's care and control of his/her children" label="Does this owner have care and control of his/her children?" items={ownerChildrenCareItems} setSelectedDropdown={handleValueChange(props.item.id,"children_care_and_control")}
            />
            {props.item?.children_care_and_control === ChildrenCareControlEnum.shared_control_children && <div style={{ marginTop: 32 }}>
              <P2Alert variant={"success"} text={"Only 1 party can be listed in the flat with the children. Both parties will be required to sign a consent form within the application form."}></P2Alert>
            </div>}
          </div>}

          <SpouseForm forceError={props.forceError} item={props.item} disableFields={disableFields} handleValueChange={handleSpouseFormValueChange} itemHoldingErrors={itemHoldingErrors}/>
        </> 
      ) : null}
    </>
  )
}

const ExistingUserFormsType3 = ({ ...props }: NewOwnerAccordionProps & AdditionalFormProps) => {
  const { itemHoldingErrors, allowToggle, isToShowChildCareControl } = props
  const { owners, occupiers } = props.householdFormValues;

  const firstOwnerName = props.householdFormValues.incoming_owners && props.householdFormValues.incoming_owners.length > 0 ? props.householdFormValues.incoming_owners[0].myinfo.name : "";
  const isFirst = props.index === 0;

  const isFromCurrentHousehold = owners.some(owner => owner.myinfo.uinfin === props.item.myinfo.uinfin) || occupiers.some(occupier => occupier.myinfo.uinfin === props.item.myinfo.uinfin)
  const isPersonalDetailsShow =
    !props.hasCurrentOwner ||
    isFromCurrentHousehold ||
    (itemHoldingErrors?.myinfo?.name?.isValid && itemHoldingErrors?.myinfo?.uinfin?.isValid && props.item?.relationship_with_owner !== "");
  
  const handleValueChange = (id: string, key: string) => (value: string | boolean) => {
    props?.holdingIncomingOwnerHandler?.(id, value, key);
  }
  const disableFields = !allowToggle && props.item.is_proposed;
   // NOTE: isError to add !disabledField to prevent the error message when add owner/occupier because if not adding that, when click on add owner/occupier, the nric existed will be prompting in a glimpse.
  
  const handleSpouseFormValueChange = (value:any, field:string)=>{
    handleValueChange(props.item.id, field)(value);
  }
  
   return (
    <div style={{ marginTop: 24 }}>
      <p hidden>3</p>
      {isFirst && !isFromCurrentHousehold && SharedValidators.Uinfin(props.item.myinfo.uinfin).isValid ? (
        <>
          <div style={{ marginTop: 12 }}>
            <P2TextLabel bold="700" color={"#000"} label={"Relationship"} />
          </div>
          <div style={{ marginTop: 24 }}>
            <Dropdown
              forceError={props.forceError}
              required
              disabled={disableFields}
              selectedDropdown={props.item?.relationship_with_owner}
              placeholder="Please indicate relationship with owner"
              label="How is this proposed owner related to the current owner(s)?"
              items={incomingOwnerRelatedToAboveItemsSubsequent}
              setSelectedDropdown={handleValueChange(props.item.id, "relationship_with_owner")}
            />
          </div>
        </>
      ) : null}
      {props.index > 0 && <>
        <div style={{ marginTop: 12 }}><P2TextLabel bold="700" color={"#000"} label={"Relationship"} /></div>
        <div style={{ marginTop: 17 }}>
          <RadioGroup style={{ marginTop: 24 }} disabled={disableFields} layout={'default'} items={isRelatedToOwner} onItemSelect={handleValueChange(props.item.id,"is_related")} value={props.item?.is_related} label={`Is this proposed owner related to ${firstOwnerName}?`} />
        </div>

        {props.item?.is_related && <div style={{ marginTop: 24 }}>
          <Dropdown forceError={props.forceError} required disabled={disableFields} selectedDropdown={props.item?.relationship_with_owner} placeholder="Please indicate relationship with owner"
            label={`How is this proposed owner related to ${firstOwnerName}?`} items={incomingOwnerRelatedToAboveItems}
            setSelectedDropdown={handleValueChange(props.item.id,"relationship_with_owner")}
          />
        </div>}

        <div style={{ marginTop: 24 }}><P2TextLabel bold="700" color={"#000"} label={"Personal Details"} /></div>
      </>}
      
      <div style={{ marginTop: isFirst ? 24 : 12 }}>
        <P2TextInput forceError={props.forceError} disabled={props.item?.is_proposed} isError={((!itemHoldingErrors?.myinfo?.uinfin?.isValid) && !disableFields)} errorMsg={itemHoldingErrors?.myinfo?.uinfin?.message} required value={props.item?.myinfo?.uinfin?.toString()} name='uinfin' label='NRIC' maxLength={9} placeholder='Please enter NRIC' type='text' onChange={handleValueChange(props.item.id,"uinfin")} />
      </div>

      <div style={{ marginTop: 24 }}>
        <P2TextInput pattern={namePattern} forceError={props.forceError} disabled required value={props.item?.myinfo?.name?.toString()} name='name' label='Full name' maxLength={256} placeholder='Please enter full name' type='text' />
      </div>
      
      {isPersonalDetailsShow ? (
        <>
          <div style={{ marginTop: 24 }}>
            <P2DateSelector
              forceError={props.forceError}
              disabled={disableFields}
              isError={!itemHoldingErrors?.myinfo?.dob?.isValid}
              errorMsg={itemHoldingErrors?.myinfo?.dob?.message}
              value={props.item?.myinfo?.dob}
              required
              placeholder="DD/MM/YYYY"
              label="Date of birth"
              onChange={handleValueChange(props.item.id,"dob")}
            />
          </div>
          <div style={{ marginTop: 24 }}>
            <Dropdown
              forceError={props.forceError}
              disabled={disableFields}
              required
              selectedDropdown={props.item?.myinfo?.residential_status}
              placeholder="Please indicate residential status"
              label="Residential status"
              items={incomingOwnerCitizenshipDropdownItems}
              setSelectedDropdown={handleValueChange(props.item.id,"residential_status")}
            />
            {props.item?.myinfo?.residential_status === ResidentialStatusEnum.not_applicable && <div style={{ marginTop: 24 }}>
              <P2Alert variant={"danger"} text={"Only a Singapore citizen or Permanent Resident may own an HDB flat."}></P2Alert>
            </div>}
          </div>

          {props.item?.myinfo?.residential_status === ResidentialStatusEnum.pr &&
            <>
              <div style={{ marginTop: 24 }}>
                <P2DateSelector
                  isError={!itemHoldingErrors?.spr_obtained_date?.isValid} 
                  errorMsg={itemHoldingErrors?.spr_obtained_date?.message}
                  forceError={props.forceError}
                  disabled={disableFields}
                  value={props.item?.spr_obtained_date}
                  required
                  placeholder="DD/MM/YYYY"
                  label="Date of obtaining SPR status" 
                  maxInput={new Date().toISOString().split("T")[0].toString()}
                  onChange={handleValueChange(props.item.id,"spr_obtained_date")}
                />
              </div>
              {props.item?.spr_obtained_date && !checkDOB(props.item?.spr_obtained_date, 3) && 
              <div style={{ marginTop: 32 }}>
                <InfoCard
                    className="polymer-alert-card"
                    style={{ backgroundColor: "#FFF0C9", color: "#80460D" }}
                    description={
                      <div>
                        An individual Singapore Permanent Resident (SPR) would need to obtain his/her SPR status for at least 3 years to be eligible as one of the proposed owners, if the other owners are also SPRs.
                      </div>
                    }
                    icon={<DangerCircle color="#80460D" />}
                  />
              </div>}
            </>}

          <div style={{ marginTop: 24 }}>
            <Dropdown
              forceError={props.forceError}
              disabled={disableFields}
              required
              selectedDropdown={props.item?.myinfo?.marital_status}
              placeholder="Please indicate marital status"
              label="Marital status"
              items={maritalStatusDropdownItems}
              setSelectedDropdown={handleValueChange(props.item.id,"marital_status")}
            />
          </div>

          {isToShowChildCareControl && <div style={{ marginTop: 24, marginBottom: 24 }}>
            <Dropdown
              forceError={props.forceError}
              disabled={disableFields}
              required
              selectedDropdown={props.item?.children_care_and_control}
              placeholder="Please indicate owner's care and control of his/her children"
              label="Does this owner have care and control of his/her children?"
              items={ownerChildrenCareItems}
              setSelectedDropdown={handleValueChange(props.item.id,"children_care_and_control")}
            />
            {props.item?.children_care_and_control === ChildrenCareControlEnum.shared_control_children && <div style={{ marginTop: 24 }}>
              <P2Alert variant={"success"} text={"Only 1 party can be listed in the flat with the children. Both parties will be required to sign a consent form within the application form."}></P2Alert>
            </div>}
          </div>}

          <SpouseForm forceError={props.forceError} item={props.item} disableFields={disableFields} handleValueChange={handleSpouseFormValueChange} itemHoldingErrors={itemHoldingErrors}/>
        </>
      ) : null}
    </div>
  )
}

const NewUserForms = ({ ...props }: NewOwnerAccordionProps & AdditionalFormProps) => {
  const { itemHoldingErrors, allowToggle, isToShowChildCareControl } = props
  
  const handleValueChange = (id: string, key: string) => (value: string | boolean) => {
    props?.holdingIncomingOwnerHandler?.(id, value, key);
  }

  const firstOwnerName = props.householdFormValues.incoming_owners && props.householdFormValues.incoming_owners.length > 0 ? props.householdFormValues.incoming_owners[0].myinfo.name : "";
  const isAdditionalShow = itemHoldingErrors?.myinfo?.name?.isValid && itemHoldingErrors?.myinfo?.uinfin?.isValid;

  //NOTE: when no current owners, will show personal details without relationship fields.
  const isPersonalDetailsShow = (props.item?.is_related === true ? props.item?.relationship_with_owner !== "" : props.item?.is_related !== undefined && !props.item?.is_related) || !props.hasCurrentOwner;

  const isFirst = props.index === 0;
  const disableFields = !allowToggle && props.item.is_proposed;
  //NOTE: to enable props.hasCurrentOwner back when api supported this feature. https://gitlab02.decision-science.agency/hdb/hdb-change-in-flat-ownership-service/-/issues/186
  //NOTE: isError to add !disabledField to prevent the error message when add owner/occupier because if not adding that, when click on add owner/occupier, the nric existed will be prompting in a glimpse.

  const handleSpouseFormValueChange = (value:any, field:string)=>{
    handleValueChange(props.item.id, field)(value);
  }
  return (
    <>
      <p hidden>new</p>
      {isFirst && props.hasCurrentOwner && <>

        <div style={{ marginTop: 12 }}><P2TextLabel bold="700" color={"#000"} label={"Relationship"} /></div>
        <div style={{ marginTop: 24 }}>
          <Dropdown forceError={props.forceError} required disabled={disableFields} selectedDropdown={props.item?.relationship_with_owner} placeholder="Please indicate relationship with owner" label="How is this proposed owner related to the current owner(s)?" items={incomingOwnerRelatedToAboveItemsSubsequent}
            setSelectedDropdown={handleValueChange(props.item.id,"relationship_with_owner")}
          />
        </div>
        <div style={{ marginTop: isFirst ? 24 : 12 }}><P2TextLabel bold="700" color={"#000"} label={"Personal Details"} /></div>
      </>}

      {props.index > 0 && <>
        <div style={{ marginTop: 12 }}><P2TextLabel bold="700" color={"#000"} label={"Relationship"} /></div>
        <div style={{ marginTop: 17 }}>
          <RadioGroup style={{ marginTop: 24 }} disabled={disableFields} layout={'default'} items={isRelatedToOwner} onItemSelect={handleValueChange(props.item.id,"is_related")} value={props.item?.is_related} label={`Is this proposed owner related to ${firstOwnerName}?`} />
        </div>

        {props.item?.is_related && <div style={{ marginTop: 24 }}>
          <Dropdown forceError={props.forceError} required disabled={disableFields} selectedDropdown={props.item?.relationship_with_owner} placeholder="Please indicate relationship with owner"
            label={`How is this proposed owner related to ${firstOwnerName}?`} items={incomingOwnerRelatedToAboveItems}
            setSelectedDropdown={handleValueChange(props.item.id,"relationship_with_owner")}
          />
        </div>}

        <div style={{ marginTop: 24 }}><P2TextLabel bold="700" color={"#000"} label={"Personal Details"} /></div>
      </>}

      <div style={{ marginTop: isFirst ? 24 : 12 }}>
        <P2TextInput forceError={props.forceError} disabled={props.item?.is_proposed} isError={((!itemHoldingErrors?.myinfo?.uinfin?.isValid) && !disableFields)} errorMsg={itemHoldingErrors?.myinfo?.uinfin?.message} required value={props.item?.myinfo?.uinfin?.toString()} name='uinfin' label='NRIC' maxLength={9} placeholder='Please enter NRIC' type='text' onChange={handleValueChange(props.item.id,"uinfin")} />
      </div>

      <div style={{ marginTop: 24 }}>
        <P2TextInput pattern={namePattern} forceError={props.forceError} disabled={disableFields} isError={!itemHoldingErrors?.myinfo?.name?.isValid} errorMsg={itemHoldingErrors?.myinfo?.name?.message} required value={props.item?.myinfo?.name?.toString()} name='name' label='Full name' maxLength={256} placeholder='Please enter full name' type='text' onChange={handleValueChange(props.item.id,"name")} />
      </div>
      {isAdditionalShow && <>
        {isPersonalDetailsShow && <>
          <div style={{ marginTop: 24 }}>
            <P2DateSelector forceError={props.forceError} isError={!itemHoldingErrors?.myinfo?.dob?.isValid} errorMsg={itemHoldingErrors?.myinfo?.dob?.message} value={props.item?.myinfo?.dob} required placeholder="DD/MM/YYYY" label="Date of birth" disabled={disableFields} 
              onChange={handleValueChange(props.item.id,"dob")}
            />
          </div>
          <div style={{ marginTop: 24 }}>
            <Dropdown forceError={props.forceError} disabled={disableFields} required selectedDropdown={props.item?.myinfo?.residential_status} placeholder="Please indicate residential status" label="Residential status" items={incomingOwnerCitizenshipDropdownItems} setSelectedDropdown={handleValueChange(props.item.id,"residential_status")}
            />
            {props.item?.myinfo?.residential_status === ResidentialStatusEnum.not_applicable && <div style={{ marginTop: 24 }}>
              <P2Alert variant={"danger"} text={"Only a Singapore citizen or Permanent Resident may own an HDB flat."}></P2Alert>
            </div>}
          </div>

          {props.item?.myinfo?.residential_status === ResidentialStatusEnum.pr &&
            <>
              <div style={{ marginTop: 24 }}>
                <P2DateSelector isError={!itemHoldingErrors?.spr_obtained_date?.isValid} errorMsg={itemHoldingErrors?.spr_obtained_date?.message} forceError={props.forceError} disabled={disableFields} value={props.item?.spr_obtained_date} required placeholder="DD/MM/YYYY" label="Date of obtaining SPR status" maxInput={new Date().toISOString().split("T")[0].toString()} onChange={handleValueChange(props.item.id,"spr_obtained_date")}
                />
              </div>
              {props.item?.spr_obtained_date && !checkDOB(props.item?.spr_obtained_date, 3) && 
            <div style={{ marginTop: 32 }}>
              <InfoCard
                  className="polymer-alert-card"
                  style={{ backgroundColor: "#FFF0C9", color: "#80460D" }}
                  description={
                    <div>
                      An individual Singapore Permanent Resident (SPR) would need to obtain his/her SPR status for at least 3 years to be eligible as one of the proposed owners, if the other owners are also SPRs.
                    </div>
                  }
                  icon={<DangerCircle color="#80460D" />}
                />
            </div>}
            </>
          }

          <div style={{ marginTop: 24 }}>
            <Dropdown forceError={props.forceError} disabled={disableFields} required selectedDropdown={props.item?.myinfo?.marital_status} placeholder="Please indicate marital status" label="Marital status" items={maritalStatusDropdownItems} setSelectedDropdown={handleValueChange(props.item.id,"marital_status")}/>
          </div>

          {isToShowChildCareControl && <div style={{ marginTop: 24, marginBottom: 24 }}>
            <Dropdown
              forceError={props.forceError}
              disabled={disableFields}
              required
              selectedDropdown={props.item?.children_care_and_control}
              placeholder="Please indicate owner's care and control of his/her children"
              label="Does this owner have care and control of his/her children?"
              items={ownerChildrenCareItems}
              setSelectedDropdown={handleValueChange(props.item.id,"children_care_and_control")}
            />
            {props.item?.children_care_and_control === ChildrenCareControlEnum.shared_control_children && <div style={{ marginTop: 24 }}>
              <P2Alert variant={"success"} text={"Only 1 party can be listed in the flat with the children. Both parties will be required to sign a consent form within the application form."}></P2Alert>
            </div>}
          </div>}
          
          <SpouseForm forceError={props.forceError} item={props.item} disableFields={disableFields} handleValueChange={handleSpouseFormValueChange} itemHoldingErrors={itemHoldingErrors}/>
          
        </>}

      </>
      }
    </>
  )
}



function NewOwnerAccordion({ ...props }: NewOwnerAccordionProps) {

  const AppDispatch = useAppDispatch();


  const isProposed = props.item ? props.item?.is_proposed : false;
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const [allowToggle, setAllowToggle] = useState<boolean>(false);
  const accordionRef = useRef<any>();
  
  
  const [saveAlertShow, setSaveAlertShow] = useState<boolean>(false);
  const [isInit, setIsInit] = useState<boolean>(false);
  const accordionEventRef = useRef<any>();

  const bindProcess = useCallback((res:any)=>{
    const errorMessage = "We are unable to retrieve your information from Myinfo. Please enter your personal details manually.";
    if(isNaN(res.payload)){
      const myInfoData:MyInfo = new MyInfo({...res.payload, uinfin: PolymerCrypto.decryption(res.payload.uinfin)});
      if(myInfoData.dob && myInfoData.dob.split("-").length < 3) {
          setRetrieve(false)
          alert(errorMessage)
          return;
      }
      if(props.onBindMyInfo && props.item.original_uinfin){
        props.onBindMyInfo(props.item.original_uinfin, myInfoData);
      }
    } else {
      setRetrieve(false)
      alert(errorMessage)
    }
  },[props])

  const retrieveOwnerCallBack = useCallback(()=>{
    AppDispatch(retrieveMyInfoByNRIC({ uinfin: props.item.original_uinfin, singpass_code: props.singpassToken , allow_my_info: true })).then(bindProcess).finally(()=>{
      myInfoLoadingValue(false);
    });
  },[AppDispatch, bindProcess, props.item.original_uinfin, props.singpassToken]);
  

  const clearOwnerCallBack = useCallback(()=>{
    AppDispatch(retrieveMyInfoByNRIC({ uinfin: props.item.original_uinfin, singpass_code: props.singpassToken , allow_my_info: false })).finally(()=>{
      if(props.onUnBindMyInfo && props.item.original_uinfin){
        props.onUnBindMyInfo(props.item.original_uinfin);
      }
    }).finally(()=>{ myInfoLoadingValue(false);});
  },[AppDispatch, props])

  const { isRetrieve, isMyInfoLoading, toShowMyInfo, toggleRetrieveMyInfo, myInfoLoadingValue, setRetrieve  } = useRetrieveMyInfo(props.item, allowToggle, retrieveOwnerCallBack, clearOwnerCallBack);


  const formType = useMemo(() => {
    if (props.item.type === "existing" && props.item.original_uinfin === loginUser.uinfin) {
      return 1;
    }
    else if (props.item.type === "new") {
      //All owners except same
      return 5;
    }
    else {
      return 3;
    }

  }, [loginUser.uinfin, props.item.original_uinfin, props.item.type])



  const isToShowChildCareControl = useMemo(()=>{
    const condition1 = props.reasonValues?.change_ownership_reason === OwnershipReasonEnum.divorce && props.reasonValues?.reason === ReasonEnum.marital_status_reason_value
    // NOTE : Previous logic to be remove
    // const eligibleRelationship:RelationshipTypes[] = ["EH", "EW"];
    // const condition2 = props.item.type === "existing";
    // const condition3 = props.item.type === "new" && props.item.is_related === true && eligibleRelationship.includes(props.item.relationship_with_owner as RelationshipTypes);
    const condition4 = props.item.myinfo.marital_status === MaritalStatusEnum.divorced;
    return condition1 && (condition4);
  },[props.item.myinfo.marital_status, props.reasonValues?.change_ownership_reason, props.reasonValues?.reason])


  const { errors: itemHoldingErrors, formValid: itemHoldingFormValid, setFormValue: itemHoldingSetFormValue, setAdditionalData }: { handleChange: any, values: HoldingOwner, errors: any, formValid: boolean, setFormValue: (update: any) => void, setAdditionalData: any } = useForm(new HoldingOwner(props.item), () => { }, validateIndividualHoldingOwner);


  const isEnableBtn = useMemo(() => {
    return !itemHoldingFormValid;
  }, [itemHoldingFormValid])

  useEffect(() => {
    setAdditionalData({ "formType": formType, "reasonValues": props.reasonValues, proposed_nric: props.proposed_nric, isProposed: isProposed, isToShowChildCareControl:isToShowChildCareControl, hasCurrentOwner:props.hasCurrentOwner, initialHouseholdNrics: props.initialHouseholdNrics });
    itemHoldingSetFormValue(props.item)
  }, [props.item, formType, props.reasonValues, isProposed, setAdditionalData, props.proposed_nric, isToShowChildCareControl, itemHoldingSetFormValue, props.hasCurrentOwner]);


  useEffect(() => {
    if (formType === 3 || (formType === 5 && props.index === 0)) {
      props.holdingIncomingOwnerHandler!(props.item.id, true, "is_related");
    }
  }, [formType])

  const handleToggle = useCallback((isOpen: boolean) => {
    props?.onToggle?.(isOpen);
  }, []);

  const handleAddingOwner = useCallback(() => {
    if(props.onAdd){
      props.onAdd();
      accordionRef.current.toggle();
    }
  }, [accordionRef.current, props.onAdd])

  const handleOwnerUpdate = useCallback(() => {
    setAllowToggle(false);
    setSaveAlertShow(false);
    setIsInit(false);
    if(props.onUpdate){
      props.onUpdate();
    }
  }, [props.onUpdate])


  const handleClickOutside = useCallback((event:any) => {
    if((isProposed && allowToggle) && isInit === false){
      setIsInit(true);
    }
    else{
      if (accordionEventRef.current && !accordionEventRef.current.contains(event.target)) {
        if(!isEnableBtn){
          setSaveAlertShow(true);
        }
      }
      else{
        setSaveAlertShow(false);
        setIsInit(false);
      }
    }

  },[allowToggle, isEnableBtn, isInit, isProposed]);

  const toggleEditDetails = useCallback(() => {
    setAllowToggle(true);
    setSaveAlertShow(false);
  }, [])


  const saveAlertVisible = useMemo(()=>{
    if(((isProposed && allowToggle)) && !isEnableBtn && saveAlertShow && isInit){
      return true;
    }
    else if(!isProposed && !isEnableBtn && saveAlertShow){
      return true;

    }
    else{
      setSaveAlertShow(false);
      return false;
    }
  },[allowToggle, isEnableBtn, isInit, isProposed, saveAlertShow])

  useEffect(() => {
    // Add click event listener to the document
    document.addEventListener('click', handleClickOutside);

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [handleClickOutside]); 


  return (
    <div ref={accordionEventRef}>
      <P2Accordion ref={accordionRef} defaultOpen={props.isDefaultOpen} onToggle={handleToggle} title={
        <AccordionTitle isProposed={true} item={props.item} type='owner'/>
      }
      >
          {isMyInfoLoading && <LottieLoader />}

          {!isMyInfoLoading && <>
            <p style={{
              color: '#000',
              fontWeight: 400,
              fontSize: '1.125rem',
              marginBottom: '32px',
              lineHeight: '1.5rem'
            }}>
              Please fill in the following details in order to add owner to the proposed household.
            </p>

            <div>
              {toShowMyInfo && <SingpassMyInfo hasRetrieve={isRetrieve} onClick={toggleRetrieveMyInfo} />}
              {formType === 1 && <ExistingMyInfoUserForms {...props} itemHoldingErrors={itemHoldingErrors} allowToggle={allowToggle} isToShowChildCareControl={isToShowChildCareControl} />}
              {formType === 3 && <ExistingUserFormsType3 {...props} itemHoldingErrors={itemHoldingErrors} allowToggle={allowToggle} isToShowChildCareControl={isToShowChildCareControl} />}
              {formType === 5 && <NewUserForms {...props} itemHoldingErrors={itemHoldingErrors} allowToggle={allowToggle} isToShowChildCareControl={isToShowChildCareControl} />}
            </div>

            {saveAlertVisible && <div style={{ marginTop: 24 }}>
              <P2Alert variant={"danger"} text={"Please save details to proceed."}></P2Alert>
            </div>}

            <div className="polymer-buttons-wrapper">
              <P2Button onClick={props.onRemove} variant={"text-icon"} style={{ fontSize: '1rem' }}>Delete record</P2Button>
              {!isProposed && <P2Button disabled={isEnableBtn} onClick={handleAddingOwner} variant={"outline-primary"}>Save details</P2Button>}
              {isProposed && allowToggle && <P2Button disabled={isEnableBtn} onClick={handleOwnerUpdate} variant={"outline-primary"}>Save details</P2Button>}
              {isProposed && !allowToggle && <P2Button disabled={isEnableBtn} onClick={toggleEditDetails} variant={"outline-primary"} style={{ fontSize: '1rem' }}>Edit details</P2Button>}
            </div>
          </>}
      </P2Accordion>
    </div>

  )
}

export default NewOwnerAccordion